async function avatars(options = {}) {
    const hash = options.hash || Buffer.from(await crypto.subtle.digest('sha-256', new TextEncoder().encode(options.identifier))).toString('hex')
    const baseUrls = [
        new URL(`https://www.gravatar.com/avatar/${hash}?s=512&d=identicon`),
        new URL(`${document.location.origin}/avatar/${hash}?s=512`)
    ]

    const avatars = baseUrls.map(baseUrl => {
        baseUrl.search = new URLSearchParams(options.params || {})

        return baseUrl.toString()
    })

    return avatars
}
function formatNumber(number) {
    // Use the toLocaleString method to add suffixes to the number
    return Number(number).toLocaleString('en-US', {
        // add suffixes for thousands, millions, and billions
        // the maximum number of decimal places to use
        maximumFractionDigits: 2,
        // specify the abbreviations to use for the suffixes
        notation: 'compact',
        compactDisplay: 'short'
    })
}
function toStatString(type, userId, timestamp, entityId) {
    return `${type}:${userId}:${timestamp ? `:${timestamp}` : ''}${entityId ? `:${entityId}` : ''}`
}
function parseStatString(str) {
    const [type, userId, timestamp, entityId] = str.split(':')

    return Object.fromEntries(Object.entries({ type, userId, timestamp, entityId }).filter(([_, value]) => Boolean(value)))
}

export {
    avatars,
    formatNumber,
    toStatString,
    parseStatString
}